import type {ProductFilterName, ProductUrlFilters} from '../../types';

import {SortAscendingOutlined} from '@ant-design/icons';
import {BottomSheet, Button, Chip, Radio} from '@ds/components';
import {useState} from 'react';

import {PRODUCT_FILTER_OPTIONS, PRODUCT_FILTER_TITLES} from '../../constants';

type ProductFiltersProps = {
  filters: ProductUrlFilters;
  onChange: (filters: ProductUrlFilters) => void;
  onClear: (name: ProductFilterName) => void;
};

const ProductFilters: React.FC<ProductFiltersProps> = ({filters, onChange, onClear}) => {
  const [activeFilter, setActiveFilter] = useState<ProductFilterName | null>(null);
  const [draftValue, setDraftValue] = useState('');

  const openFilter = (name: ProductFilterName) => {
    setActiveFilter(name);
    setDraftValue(filters[name] ?? '');
  };

  const closeFilter = () => {
    setActiveFilter(null);
    setDraftValue('');
  };

  return (
    <>
      <div className="flex min-h-12 overflow-x-auto border-b border-gray-02 px-4 py-2">
        <div className="flex w-max gap-2">
          {(Object.keys(PRODUCT_FILTER_TITLES) as ProductFilterName[]).map((name) => {
            const selected = Boolean(filters[name]);
            return (
              <Chip
                key={name}
                label={PRODUCT_FILTER_TITLES[name]}
                icon={name === 'sort' ? <SortAscendingOutlined /> : undefined}
                selected={selected}
                onClick={() => openFilter(name)}
              />
            );
          })}
        </div>
      </div>

      <BottomSheet
        show={activeFilter !== null}
        defaultHeader
        title={activeFilter ? PRODUCT_FILTER_TITLES[activeFilter] : ''}
        onClose={closeFilter}
        footer={
          activeFilter ? (
            <div className="flex flex-col gap-2 p-3">
              <Button
                fullWidth
                disabled={!draftValue}
                onClick={() => {
                  onChange({...filters, [activeFilter]: draftValue});
                  closeFilter();
                }}
              >
                تایید
              </Button>
              <Button
                fullWidth
                variant="ghost"
                disabled={!filters[activeFilter]}
                onClick={() => {
                  onClear(activeFilter);
                  closeFilter();
                }}
              >
                حذف فیلتر
              </Button>
            </div>
          ) : null
        }
      >
        {activeFilter && (
          <Radio.Group
            className="px-4"
            value={draftValue}
            onChange={(event) => setDraftValue(event.target.value)}
          >
            {PRODUCT_FILTER_OPTIONS[activeFilter].map((option) => (
              <Radio
                key={option.value}
                value={option.value}
                className="w-full border-b border-gray-03 py-4 last:border-0"
              >
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
        )}
      </BottomSheet>
    </>
  );
};

export default ProductFilters;
